module.exports = __webpack_public_path__ + "img/close.e19851ca.svg";